var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.src)?_c('img',{attrs:{"src":_vm.src,"alt":_vm.alt}}):_c('img',{staticClass:"default",attrs:{"src":"//statics.affili.ir/storage/assets/logo/affili-signet-white.png","alt":_vm.alt}})
}
var staticRenderFns = []

export { render, staticRenderFns }